import { createContext, useContext } from 'react';

export type ActivePlan = {
  type: string;
  level: number;
  subscriptionCancelDate?: string;
  manualSubscription: boolean;
};

export type BillingPeriod = 'Yearly' | 'Monthly';

type BillingPlansContextType = {
  activePlan?: ActivePlan;
  refetchPlans: () => void;
};

export const BillingPlansContext = createContext({} as BillingPlansContextType);

export const useBillingPlansContext = () => {
  const context = useContext(BillingPlansContext);
  if (context === undefined) {
    throw new Error(
      'useBillingPlansContext must be used within BillingPlansProvider',
    );
  }
  return context;
};
